<script setup>
const basketStore = useBasketStore()
const authStore = useAuthStore()
const { settings } = storeToRefs(authStore)

await useSettings()
await useMenu()
</script>

<template>
  <div>
    <MtgsNs />
    <NuxtLoadingIndicator
      color="#fff"
      :throttle="500"
    />
    <ClientOnly>
      <Teleport to="body">
        <ContactEmail
          id="summary-email"
          :items="[settings?.help_email]"
        />
        <ContactPhone
          id="summary-phone"
          :items="[settings?.help_phone]"
        />
      </Teleport>
    </ClientOnly>
    <div class="container container--main">
      <PageNavigation />
      <slot />
      <PageSeoFooter />
      <PageFooter />
    </div>
    <ClientOnly>
      <LazyGlobalAlert />
      <LazySearchMask />
      <LazyModalShoppingCart />
      <LazyProductShoppingCart
        id="common"
        :message="true"
        :quantity="basketStore.cartModalVal('common', 'quantity')"
        :price-info="basketStore.cartModalVal('common', 'price')"
        :payment="true"
      />
    </ClientOnly>
  </div>
</template>

<style lang="scss" scoped></style>
